import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    azienda: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5l9i4mm3t2gksp8clvg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefono: '',
          azienda: '',
          messaggio: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contatti" className="py-32 bg-[#F8F6F3]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-8">
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight">
              PARLIAMO DEL<br />
              TUO PROGETTO
            </h2>
          </div>
          <div className="max-w-md">
            <p className="text-gray-600 font-light leading-relaxed">
              Siamo pronti ad ascoltare le tue esigenze e a proporti la soluzione tecnologica più adatta per il tuo business.
            </p>
          </div>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-16">
          {/* Company Info Card */}
          <div className="bg-[#2C2C2C] rounded-2xl p-10 text-white">
            <h3 className="text-2xl font-bold mb-6">Lios S.r.l.</h3>
            <div className="space-y-4 mb-8">
              <p className="text-white/80 font-light leading-relaxed">
                Via Vittorio Emanuele III 159/161<br />
                80027 Frattamaggiore (NA)<br />
                Italia
              </p>
            </div>
            <div className="relative h-48 rounded-xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/6b209d8241a0edcb1fce2c73c5c3e926/191da2a91f225402e5d72a6446d7552a.jpeg"
                alt="Lios Office"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Fiscal Data Card */}
          <div className="bg-white rounded-2xl p-10 border border-gray-200">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-text-line text-xl text-[#1A4D4D]"></i>
              </div>
              <span className="text-sm font-medium text-[#2C2C2C]">Dati Fiscali</span>
            </div>
            <div className="flex flex-col items-center justify-center text-center py-8">
              <div className="w-20 h-20 flex items-center justify-center mb-6 bg-[#F8F6F3] rounded-2xl">
                <i className="ri-file-list-3-line text-4xl text-[#1A4D4D]"></i>
              </div>
              <p className="text-2xl font-bold text-[#2C2C2C] mb-4">P.IVA: 08771441212</p>
              <p className="text-gray-600 font-light text-sm break-all">
                PEC: liossrl@unapec.it
              </p>
            </div>
          </div>

          {/* Direct Contacts Card */}
          <div className="bg-white rounded-2xl p-10 border border-gray-200">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-xl text-[#1A4D4D]"></i>
              </div>
              <span className="text-sm font-medium text-[#2C2C2C]">Contatti Rapidi</span>
            </div>
            <div className="flex flex-col items-center justify-center text-center py-8">
              <div className="w-20 h-20 flex items-center justify-center mb-6 bg-[#F8F6F3] rounded-2xl">
                <i className="ri-phone-line text-4xl text-[#1A4D4D]"></i>
              </div>
              <a 
                href="mailto:commerciale.liosrl@gmail.com"
                className="text-lg font-semibold text-[#2C2C2C] mb-4 hover:text-[#1A4D4D] transition-colors break-all cursor-pointer"
              >
                commerciale.liosrl@gmail.com
              </a>
              <a 
                href="tel:+390811881069"
                className="text-xl font-bold text-[#1A4D4D] hover:text-[#2D5F5F] transition-colors cursor-pointer whitespace-nowrap mt-2"
              >
                081 18810690
              </a>
              <p className="text-gray-500 text-sm mt-1 font-light">Telefono fisso</p>
              <a 
                href="tel:+393514265388"
                className="text-xl font-bold text-[#1A4D4D] hover:text-[#2D5F5F] transition-colors cursor-pointer whitespace-nowrap mt-3"
              >
                +39 351 426 5388
              </a>
              <p className="text-gray-500 text-sm mt-1 font-light">Cellulare</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white rounded-2xl p-10 lg:p-16 shadow-sm">
          <h3 className="text-3xl font-bold text-[#2C2C2C] mb-8">Invia una Richiesta</h3>
          
          <form id="contact_form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-[#2C2C2C] mb-2">
                  Nome e Cognome *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  value={formData.nome}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A4D4D] focus:border-transparent text-sm"
                  placeholder="Mario Rossi"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-[#2C2C2C] mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A4D4D] focus:border-transparent text-sm"
                  placeholder="mario.rossi@esempio.it"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="telefono" className="block text-sm font-medium text-[#2C2C2C] mb-2">
                  Telefono
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A4D4D] focus:border-transparent text-sm"
                  placeholder="+39 123 456 7890"
                />
              </div>
              <div>
                <label htmlFor="azienda" className="block text-sm font-medium text-[#2C2C2C] mb-2">
                  Azienda
                </label>
                <input
                  type="text"
                  id="azienda"
                  name="azienda"
                  value={formData.azienda}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A4D4D] focus:border-transparent text-sm"
                  placeholder="Nome Azienda S.r.l."
                />
              </div>
            </div>

            <div>
              <label htmlFor="messaggio" className="block text-sm font-medium text-[#2C2C2C] mb-2">
                Messaggio *
              </label>
              <textarea
                id="messaggio"
                name="messaggio"
                required
                rows={6}
                maxLength={500}
                value={formData.messaggio}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A4D4D] focus:border-transparent resize-none text-sm"
                placeholder="Descrivi il tuo progetto o le tue esigenze..."
              />
              <p className="text-xs text-gray-500 mt-1">Massimo 500 caratteri</p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                Messaggio inviato con successo! Ti contatteremo presto.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                Si è verificato un errore. Riprova più tardi.
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full md:w-auto bg-[#1A4D4D] text-white px-12 py-4 rounded-full font-medium hover:bg-[#2D5F5F] transition-all hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
            </button>
          </form>
        </div>

        {/* Map */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-lg h-96">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3016.5!2d14.2694!3d40.9567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b0f1e2e2e2e2e%3A0x1!2sVia%20Vittorio%20Emanuele%20III%2C%20159%2C%2080027%20Frattamaggiore%20NA!5e0!3m2!1sit!2sit!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Lios S.r.l. Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
